import type { WebModule } from "../../core/modules";
import { AssistantChat, AssistantLauncher } from "./components/chat";
const assistant: WebModule = {
  name: "x-assistant",
  routes: [
    {
      path: "/assistant",
      element: (
        <div className="assistant-page">
          <AssistantChat />
        </div>
      ),
      adminOnly: true,
    },
  ],
  nav: [
    {
      title: "Assistant",
      order: 25,
      adminOnly: true,
      items: [{ to: "/assistant", label: "Léo · Assistant", icon: "sparkles", adminOnly: true }],
    },
  ],
  topbar: <AssistantLauncher />,
};
export default assistant;
